import { render, staticRenderFns } from "./MetricsComponent.vue?vue&type=template&id=364cbd3e&scoped=true"
import script from "./MetricsComponent.vue?vue&type=script&lang=js"
export * from "./MetricsComponent.vue?vue&type=script&lang=js"
import style0 from "./MetricsComponent.vue?vue&type=style&index=0&id=364cbd3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364cbd3e",
  null
  
)

export default component.exports